import React from "react"
import { sayiGirdisiniDuzelt } from "./sayiGirdisi";
import { paraMetniniBicimle, paraYaziminiSuz } from "./paraGirdisi";

interface Props {
    isDisabled: boolean
    value: string | undefined
    setValue: React.Dispatch<React.SetStateAction<string | undefined>> | ((_value: string) => void) | undefined
    tabIndex: number | undefined
    maxLength: number | undefined
    labelText: string | undefined
    isLabelRequired: boolean
    allowNegative: boolean
    /**
     * Türkçe para alanı (paraGirdisi): "1.250.000,50" yazılır ve gösterilir, sağa yaslı; alan bırakılınca biçimlenir.
     * Değer metin olarak kalır; sayıya paraMetniniOku ile çevrilir. Kapalıyken eski davranış (sayiGirdisi) aynen sürer.
     */
    paraBicimi: boolean
}

const CustomNumberInput = ({
    isDisabled,
    value,
    setValue,
    tabIndex,
    maxLength,
    labelText,
    isLabelRequired,
    allowNegative,
    paraBicimi
}: Props) => {
    return (
        <React.Fragment>
            {
                labelText && (
                    <label className={"form-label " + (isLabelRequired ? 'required' : '')}>{labelText}</label>
                )
            }

            <input
                tabIndex={tabIndex}
                disabled={isDisabled}
                maxLength={maxLength}
                style={{ background: (isDisabled ? '#f1f1f4' : undefined), border: '1px solid #F1F1F4', textAlign: paraBicimi ? 'right' : undefined }}
                value={value}
                inputMode={paraBicimi ? 'decimal' : undefined}
                onChange={setValue ? (e) => setValue(paraBicimi ? paraYaziminiSuz(e.target.value, allowNegative) : sayiGirdisiniDuzelt(e.target.value, allowNegative)) : undefined}
                onBlur={setValue && paraBicimi ? (e) => setValue(paraMetniniBicimle(e.target.value)) : undefined}
                type="text"
                className="form-control form-control-solid"
            />
        </React.Fragment>
    )
}

CustomNumberInput.defaultProps = {
    isDisabled: false,
    setValue: undefined,
    tabIndex: undefined,
    maxLength: undefined,
    labelText: undefined,
    isLabelRequired: false,
    allowNegative: false,
    paraBicimi: false
}

export default CustomNumberInput;